<mat-form-field *ngIf="show">
  <mat-label>Select user role</mat-label>
  <mat-select [compareWith]="compareFn" [(value)]="selected" (selectionChange)="selectionChange($event.value)">
    <mat-option *ngFor="let role of availableRoles" [value]="role">
      {{ role.description }}
    </mat-option>
  </mat-select>
</mat-form-field>

<span *ngIf="!show">
  {{ (userRole$ | async)?.name }}
</span>
